
import CollateralViewer from './collateralviewer'

export default CollateralViewer;